import {Injectable, NgZone} from '@angular/core';
import {environment} from '../../environments/environment';
import {ParkingDeck} from './data.service';
import {BehaviorSubject, of, Subject, timer} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError, mapTo, retry, startWith, switchMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventSourceService {

  private es: EventSource;
  private eventSubject = new Subject<ParkingDeck[]>();
  public readonly parkingDeckData$;

  public readonly working$;

  constructor(private zone: NgZone, private http: HttpClient) {
    const working = new BehaviorSubject(true);

    if ('EventSource' in window) {
      this.es = new EventSource(environment.serverUrl + '/stream');
      (window as Window).onunload = () => {
        this.es.close();
        console.log('closed event source');
      };

      this.es.addEventListener('message', (m: any) => {
        const data: ParkingDeck[] = JSON.parse(m.data);
        zone.run(() => this.eventSubject.next(data), working.next(true));
      });

      this.es.addEventListener('error', e => {
        zone.run(() => this.eventSubject.error(e), working.next(false));
      });
    } else {
      timer(0, 60000)
        .pipe(
          switchMap(t => http.get(environment.serverUrl))
        )
        .subscribe(this.eventSubject);
    }


    this.working$ = working.asObservable();

    const events$ = this.eventSubject.asObservable();


    this.parkingDeckData$ = events$.pipe(retry());
  }

  public get isLive$() {
    // return 'EventSource' in window;
    return this.working$;
  }
}
